import React, { useCallback, useMemo, useState } from 'react';
import { View } from 'react-native';

import { Tab } from './Tab';
import { styles } from './styles';
import { getData } from '@/screens/WordSet/config';

export function TabsContainer({ options = [], defaultTab, children }) {
  const [activeTab, setActiveTab] = useState(defaultTab);

  const ChildrenCloned = useMemo(() => {
    return React.cloneElement(children, {
      data: getData(activeTab.id),
      keyName: activeTab.keyName,
    });
  }, [JSON.stringify(getData(activeTab.id))]);

  const changeActiveTab = useCallback((tab) => {
    setActiveTab(tab);
  }, []);

  return (
    <View style={styles.container}>
      <View style={styles.tabsContainer}>
        {options.map(({ id, tabName, keyName }) => {
          const isActive = activeTab.id === id;
          return (
            <Tab
              key={id}
              id={id}
              isActive={isActive}
              onPress={changeActiveTab}
              tabName={tabName}
              keyName={keyName}
            />
          );
        })}
      </View>
      {ChildrenCloned}
    </View>
  );
}
